/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementDecision {
    USER_REPLACE = 'user_replace',
    AUTO_REPLACE = 'auto_replace',
    SKIP = 'skip',
    PENDING = 'pending',
}
